import React, { useState } from 'react';
import { TextField } from '@mui/material';

type AadhaarNumberFieldProps = {
  label: string;
  value: string | null; // The Aadhaar number as a string or null for empty.
  onChange: (value: string | null) => void; // Function to handle value changes.
  required: boolean;
  width?: string | "200px"; // Optional width for the input.
};

export const AadhaarNumberField: React.FC<AadhaarNumberFieldProps> = ({
  label,
  value,
  onChange,
  required,
  width,
}) => {

  // Handle input change for Aadhaar number (accept only digits)
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Allow only digits
    if (!/^\d*$/.test(inputValue)) return;

    // Max 10 digits
    if (inputValue.length > 12) return;

    // Empty → null
    if (inputValue === "") {
      onChange(null);
      return;
    }

    onChange(inputValue);
  };

  return (
    <TextField
      label={label}
      value={value || ""} // Display empty string if value is null
      onChange={handleChange}
      required={required}
      size="small"
      sx={{ width: width }}
      slotProps={{
        htmlInput: {
          inputMode: 'numeric', // Numeric keypad on mobile devices
          maxLength: 12,        // hard stop at 10 digits
        }
      }}
    />
  );
};
